/* shop.js — Shop page logic, ported verbatim from pages/shop/100X Equine Shop.html.
   Category filter chips + [data-add] buttons that dispatch gx:add-to-cart to the shared cart drawer
   (pdp-bundle-module.js). Nav/drawer script + #mp-toggle dev tool NOT ported (global gutx-header owns nav). */
    (function () {
      // ----- Filtering -----
      var filters = document.getElementById('shopFilters');
      var cards = Array.prototype.slice.call(document.querySelectorAll('.shop-card'));
      var countEl = document.getElementById('shopCount');
      var emptyEl = document.getElementById('emptyState');

      function applyFilter(cat) {
        var visible = 0;
        cards.forEach(function (c) {
          var show = cat === 'all' || c.getAttribute('data-cat') === cat;
          c.classList.toggle('is-hidden', !show);
          if (show) visible++;
        });
        countEl.textContent = visible + (visible === 1 ? ' product' : ' products');
        emptyEl.style.display = visible === 0 ? 'block' : 'none';
      }

      filters.addEventListener('click', function (e) {
        var btn = e.target.closest('.filter-chip');
        if (!btn) return;
        filters.querySelectorAll('.filter-chip').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        applyFilter(btn.getAttribute('data-cat'));
      });

      // ----- Cart: adds go to the shared cart drawer (pdp-bundle-module.jsx) -----
      var CART_KEYS = { 'Gut X': { 'gut-x': 1 }, 'Osteo-MAX': { 'osteo-max': 1 }, 'Joint Flex Plus': { 'joint-flex-plus': 1 }, 'Amino-MAX': { 'amino-max': 1 }, 'Hydra-MAX': { 'hydra-max': 1 }, 'Max Calm': { 'max-calm': 1 }, 'Foundation Stack': { 'gut-x': 1, 'osteo-max': 1 } };

      document.querySelectorAll('[data-add]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var name = btn.getAttribute('data-add');
          var items = CART_KEYS[name] || {};
          window.dispatchEvent(new CustomEvent('gx:add-to-cart', { detail: { items: items, label: name } }));
          if (btn.classList.contains('add')) {
            var orig = btn.textContent;
            btn.classList.add('added');
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.classList.remove('added'); btn.textContent = orig; }, 1600);
          }
        });
      });
    })();
